<template>
  <div class="wrap">
    <div class="container ">
    <div class="row justify-content-center">
    <div class="col-12 content" >
      <h4 class="color-w">Durchführende Agentur</h4>
      <h2>crossconnect GmbH</h2>
      <p>
        Gesellschaft mit beschränkter Haftung Werbeagentur UID-Nr:
        ATU68526856<br />
        FN: 411708 d<br />
        FB-Gericht: 1010 Wien<br />
        Sitz: 1010 Wien<br />
        Elisabethstraße 22/2 | Austria<br />
        Tel: +43 1 890 0 940<br />
        Mail: esports@crossconnect.at<br />
        <br />
        Geschäftsführer: Christoph Zenk<br />
        <br />
        Mitglied der Wirtschaftskammer Österreich<br />
      </p>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
#mainNav {
  display: none !important;
}
.wrap {
  background-color: black !important;
  font-family: "Roboto Condensed", sans-serif;
  padding-top:20vh;
}

.color-w {
    color: white !important;
}
.container {
  min-height: 100vh;
  color: white !important;
}
.container > h4,h2,p {
      color: white !important;
}
.content {
    width: 80%;
    padding-top:  40px;
}
</style>
